// Libraries
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// Services
import { ApiService, SettingService } from '../../common/modules/core/services';
//Models
import { SendEmail, Email } from '../models'

@Injectable()
export class EmailService {
    // Api Domain Url
    private apiUrl = '';
    // Url send email
    private sendEmailUrl = '/email-allocation';
    private emailUrl = '/email-template'
    constructor(
        private apiService: ApiService,
        private settingService: SettingService
    ) {
        // Get API service domain for communate.
        this.apiUrl = this.settingService.getSetting('api_service_domain');
    }

    sendEmail(sendEmail: SendEmail): Observable<any> {
        const requestUrl = this.apiUrl + this.sendEmailUrl;
        // Post command
        const body = JSON.stringify(sendEmail.command)

        return this.apiService.post(requestUrl, body); 
    }

    getEmailList(): Observable<Email[]> {
        const requestUrl = this.apiUrl + this.emailUrl;
        return this.apiService.get<Email[]>(requestUrl);
    }

    editEmail(email: Email): Observable<any> {
        const requestUrl = this.apiUrl + this.emailUrl + '/' + email.id;

        const body = JSON.stringify(email);

        return this.apiService.patch(requestUrl, body);
    }
}


// WEBPACK FOOTER //
// ./src/asa/services/EmailService.ts